import React, { useState, useEffect } from 'react';
import { updateOrder } from '../services/api';
import './EditOrderModal.css';

function EditOrderModal({ order, onClose, onOrderUpdated }) {
  const [formData, setFormData] = useState({
    customerName: '',
    pickupLocation: '',
    pickupDate: '',
    pickupTime: '',
    orderComment: '',
    items: []
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (order) {
      setFormData({
        customerName: order.customerName || '',
        pickupLocation: order.pickupLocation || '',
        pickupDate: order.pickupDate || '',
        pickupTime: order.pickupTime || '',
        orderComment: order.orderComment || '',
        items: Array.isArray(order.items) ? order.items : (order.items ? Object.values(order.items) : [])
      });
    }
  }, [order]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: field === 'quantity' ? parseInt(value) || 1 : value
    };
    setFormData(prev => ({
      ...prev,
      items: updatedItems
    }));
  };

  const handleAddItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { name: '', quantity: 1 }]
    }));
  };

  const handleRemoveItem = (index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const result = await updateOrder(order.id, formData);
      if (result.success) {
        onOrderUpdated();
        onClose();
      } else {
        setError(result.message || 'Erreur lors de la mise à jour de la commande');
      }
    } catch (err) {
      setError('Erreur lors de la mise à jour de la commande');
    } finally {
      setLoading(false);
    }
  };

  if (!order) return null;

  return (
    <div className="edit-order-modal-overlay">
      <div className="edit-order-modal-content">
        <div className="modal-header">
          <h2>Modifier la commande</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="edit-order-form">
          <div className="form-section">
            <h3>Informations client</h3>
            <div className="form-group">
              <label>Nom du client</label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>Informations de retrait</h3>
            <div className="form-group">
              <label>Lieu de retrait</label>
              <input
                type="text"
                name="pickupLocation"
                value={formData.pickupLocation}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Date</label>
                <input
                  type="date"
                  name="pickupDate"
                  value={formData.pickupDate}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Heure</label>
                <input
                  type="time"
                  name="pickupTime"
                  value={formData.pickupTime}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>Articles commandés</h3>
            <div className="items-list">
              {formData.items.map((item, index) => (
                <div key={index} className="item-row">
                  <input
                    type="text"
                    placeholder="Nom de l'article"
                    value={item.name}
                    onChange={(e) => handleItemChange(index, 'name', e.target.value)}
                    required
                  />
                  <input
                    type="number"
                    min="1"
                    placeholder="Qty"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveItem(index)}
                    className="remove-item-btn"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={handleAddItem}
              className="add-item-btn"
            >
              + Ajouter un article
            </button>
          </div>

          <div className="form-section">
            <h3>Commentaire</h3>
            <div className="form-group">
              <label>Commentaire optionnel</label>
              <textarea
                name="orderComment"
                value={formData.orderComment}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Mise à jour...' : 'Mettre à jour'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditOrderModal;
